module.exports = __WEBPACK_EXTERNAL_MODULE_532__;


//////////////////
// WEBPACK FOOTER
// external "History"
// module id = 532
// module chunks = 1